import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { ICommentData, ICommentModel } from 'src/app/shared/models/i-comment-modal';
import { PrecastSampleType } from 'src/app/shared/models/i-precast-sampletypes.modal';

@Component({
    selector: 'app-requirement-comment',
    templateUrl: 'requirement-comment.component.html',
    styleUrls: ['requirement-comment.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RequirementCommentComponent implements OnInit {
  @Output() requirementData: EventEmitter<ICommentData> = new EventEmitter();
  @Input() data: ICommentModel[] = [];
  @Input() submissionType: string;
  @Input() precastSampleTypes:PrecastSampleType[] = [];
  requirementCommentForm: FormGroup;
  constructor(private fb: FormBuilder) {
    this.requirementCommentForm = this.fb.group({
      comments: this.fb.array([]),
    });
  }

  createItem(): FormGroup {
    return this.fb.group({
      id: [null],
      projectId: [null],
      sampleTypeMasterId: [null],
      projectComment: [],
      specifiedTR: [],
      specifiedMoisture: [],
      dryTR: [],
    });
  }

  get comments(): FormArray {
    return this.requirementCommentForm.get('comments') as FormArray;
  }

  ngOnInit(): void {
    if (this.data && this.data.length) {
      this.data.forEach(() => this.addComment());
    }

    if (this.submissionType === 'native-soil') {
      this.data.forEach((item) => {
        // TODO: Remove hardcoding of sampleTypeMasterId once moved to settings file.
        item.sampleTypeMasterId = '3ab1b1ca-7964-4a72-9818-202f0b3c592b';
      });
    }
    this.requirementCommentForm.patchValue({
      comments: this.data,
    });
    this.requirementCommentForm?.valueChanges?.subscribe((frmGrp) => {
      this.requirementData?.emit({
        valid: this.requirementCommentForm?.valid,
        dirty: this.requirementCommentForm?.dirty,
        value: frmGrp.comments,
      });
    });
  }

  clearComments(): void {
    const commentsArray = this.requirementCommentForm.get('comments') as FormArray;
    commentsArray.clear();
  }

  addComment(): void {
    const commentsArray = this.requirementCommentForm.get('comments') as FormArray;
    commentsArray.push(this.createItem());
  }

  getSampleTypeName(id: string): string {
    const item = this.precastSampleTypes.find((entry:PrecastSampleType) => entry.id === id);
    return item ? item.label : '';
  }

  getOtherTypeId(): string {
    return 'a';
  }
}
